<template>
  <CustomPicker
    inputId="lesson-category-picker"
    title="title"
    placeholder=" پکیج را انتخاب کنید"
    inputLabel="انتخاب پکیج"
    :isInDialog="isInDialog"
    :closeOnSelect="closeOnSelect"
    :isDisabled="isDisabled"
    :items="lessonCategories"
    :multiple="isMultiple"
    :reduce="(lessonCategory) => lessonCategory"
    v-model="selectedLessonCategory"
  >
  </CustomPicker>
</template>

<script>
export default {
  props: {
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    defaultLessonCategoryId: {
      type: [Number, String, Array, null],
      required: false,
      default: null,
    },
    isMultiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    selectedLessonCategory: {
      handler(val) {
        this.$emit("getLessonCategory", val);
      },
    },
  },
  mounted() {
    this.getAllLessonCategories();
  },
  data() {
    return {
      isLoading: false,
      lessonCategories: null,
      selectedLessonCategory: null,
    };
  },
  methods: {
    async getAllLessonCategories() {
      try {
        this.isLoading = true;
        const _this = this;
        const getLiteLessonCategories = new GetLiteLessonCategories(_this);
        await getLiteLessonCategories.fetch((res) => {
          _this.lessonCategories = res;
          if (_this.defaultLessonCategoryId) {
            _this.selectedLessonCategory = _this.defaultLessonCategoryId;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetLiteLessonCategories } from "@/libs/Api/LessonCategory";
</script>
